import React, { useEffect, useRef, useState } from "react";
import { Box, VStack, StackDivider, Heading, useToast } from "@chakra-ui/react";
import EmailApprovalProgress from "./EmailApprovalProgress";
import StepFunctionProgress from "./StepFunctionProgress";
import { TARM_AWS_URL } from "../../api/api";
import axios from "axios";
import { useParams } from "react-router-dom";
import Loading from "../Loading/Loading";
import BatchOperationsDetails from "./BatchOperationDetails";
import DownloadResults from './DownloadResults'

const ProgressSteps = () => {
  const { author_email, run_id } = useParams();
  const [source] = useState(axios.CancelToken.source());
  const [timeStamp, setTimeStamp] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const intervalRef = useRef();
  const toast = useToast();

  useEffect(() => {
    fetchStatusOnce(author_email, run_id);
    const interval = setInterval(() => fetchStatus(), 10000);
    intervalRef.current = interval;
    return () => {
      stopFetchingStatus();
      if (source) source.cancel();
    };
  }, []);

  const stopFetchingStatus = () => {
    clearInterval(intervalRef.current);
  };

  const fetchStatusOnce = async (author_email, run_id) => {
    try {
      const response = await TARM_AWS_URL.get(
        `get-status?author_email=${author_email}&run_id=${run_id}`,
        {
          cancelToken: source.token,
        }
      );
      console.log(response);
      let timeStamp = response.data;
      setTimeStamp(timeStamp);
    } catch (error) {
      console.error(error);
      stopFetchingStatus();
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchStatus = async () => {
    try {
      const response = await TARM_AWS_URL.get(
        `get-status?author_email=${author_email}&run_id=${run_id}`,
        {
          cancelToken: source.token,
        }
      );
      console.log(response);
      let timeStamp = response.data;
      setTimeStamp(timeStamp);
      if (
        timeStamp.batch_op_status === "SUCCEEDED" ||
        timeStamp.batch_op_status === "FAILED" ||
        timeStamp.batch_op_status === "TIMED_OUT" ||
        timeStamp.batch_op_status === "ABORTED"
      ) {
        stopFetchingStatus();
      }
    } catch (error) {
      console.error(error);
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return isLoading ? (
    <Loading loading={isLoading} />
  ) : (
    <VStack>
      <Heading>Batch operation progress</Heading>
      <br />
      <Box borderWidth="3px" borderRadius="lg" p="10" width="1050px">
        <BatchOperationsDetails timeStamp={timeStamp} />
        <VStack
          divider={<StackDivider borderColor="gray.200" />}
          spacing={10}
          align="stretch"
        >
          <EmailApprovalProgress status={timeStamp?.email_approval_status} />
          <StepFunctionProgress status={timeStamp?.batch_op_status} />
          {
            timeStamp?.batch_op_status === 'SUCCEEDED' &&
            <DownloadResults author_email={timeStamp.author_email} run_id={timeStamp.run_id} />
          }
        </VStack>
      </Box>
    </VStack>
  );
};

export default ProgressSteps;
